import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  error: '',
  success: '',
  user: {},
};

const UserSlice = createSlice({
  name: 'Profile',
  initialState,
  reducers: {
    profileSuccess(state, action) {
      state.success = action.payload.status;
      state.user = action.payload.data;
    },
    profileError(state, action) {
      state.error = action.payload;
    },
    resetProfileFlagChange(state: any) {
      state.success = null;
    },
  },
});

export const { profileSuccess, profileError, resetProfileFlagChange } = UserSlice.actions;

export default UserSlice.reducer;
